<template>
  <div class="flex flex-col gap-y-1">
    <div
      v-if="label && labelPosition === 'above'"
      class="font-secondary text-[12px] leading-[16px] text-gray-500"
    >
      {{ label }}
    </div>

    <div class="flex items-center gap-x-2">
      <ThumbnailIcon
        v-if="icon"
        class="w-5 h-5 rounded-xs bg-gray-200/25 p-px shrink-0"
        :icon-size="14"
        :image-url="icon.imageUrl"
        :type="icon.type"
      />
      <div
        v-if="title"
        class="font-secondary font-medium text-[13px] leading-[20px] text-gray-800"
      >
        {{ title }}
      </div>
    </div>

    <div
      v-if="label && labelPosition === 'below'"
      class="font-secondary text-[12px] leading-[16px] text-gray-500"
    >
      {{ label }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ThumbnailIcon } from '@dacr/ui'
import type { FileType } from '@/shared/graphql/router/graphql'

withDefaults(
  defineProps<{
    label?: string
    title?: string
    icon?: { type: FileType; imageUrl?: string | null }
    labelPosition?: 'above' | 'below'
  }>(),
  {
    labelPosition: 'above',
  }
)
</script>
